module.exports = __webpack_public_path__ + "e1bf609bf111e24494cbca6d83ff1e15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icon/growth.svg
// module id = 2003
// module chunks = 0